import type { ReactNode } from "react";

/**
 * 텍스트 노드 안의 React 엘리먼트 자리표시자(__REACT_ELEMENT_key__)를 실제 노드로 복원한다.
 * 자리표시자가 없으면 원문을 그대로 반환한다.
 */
export const processText = (
  data: string,
  components: Record<string, ReactNode>
): ReactNode[] => {
  const parts = data.split(/(__REACT_ELEMENT_\w+__)/g);

  return parts.map(part => {
    const matched = part.match(/^__REACT_ELEMENT_(.+?)__$/);
    return matched
      ? (components[`__REACT_ELEMENT_${matched[1]}__`] ?? part)
      : part;
  });
};
